import { forEach, get, pickBy, includes } from 'lodash';

import CollectionAPI from 'api/Collection';
import ACTIONS from 'state/constants';
import Customer from 'utils/Customer';
import Log from 'utils/Log';

const fetchCatalogMasterProduct =
  ({ handle, parentCollectionSortOrder, priceTiers, signal }) =>
  async dispatch => {
    dispatch({
      type: ACTIONS.FETCH_CATALOG_MASTER_PRODUCT_REQUEST,
      payload: { handle },
    });

    try {
      const collection = await CollectionAPI.fetchCollection({
        handle,
        sortOrder: parentCollectionSortOrder,
        priceTiers,
      });

      // Filter out any Products not within the given priceTiers, if they exist.
      if (priceTiers && priceTiers.length > 0) {
        const priceTierFilteredProducts = pickBy(collection.products, product => {
          return includes(priceTiers, product.priceTier);
        });
        collection.products = priceTierFilteredProducts;
      }

      dispatch({
        type: ACTIONS.FETCH_CATALOG_MASTER_PRODUCT_SUCCESS,
        payload: { handle, ...collection },
      });

      signal?.onSuccess(collection);
    } catch (error) {
      const sessionReplayId = Customer.sessionReplayId;
      Log.error(
        error,
        `Fetch master collection: ${handle} failed. ${sessionReplayId ? "Amplitude's session: " + sessionReplayId : ''}.`
      );

      dispatch({
        type: ACTIONS.FETCH_CATALOG_MASTER_PRODUCT_FAILURE,
        payload: {
          handle,
          errorMessage: error.message,
        },
      });

      signal?.onFailiure();
    }
  };

const setCatalogParentCollection =
  ({ parentCollectionData }) =>
  dispatch => {
    dispatch({ type: ACTIONS.SET_CATALOG_PARENT_COLLECTION, payload: { ...parentCollectionData } });
  };

const initCatalogParentCollection =
  ({ parentCollectionData, parentCollectionSortOrder }) =>
  dispatch => {
    dispatch(setCatalogParentCollection({ parentCollectionData }));

    const masterProductHandles = get(parentCollectionData, 'childCollectionSortOrder');
    const priceTiers = get(parentCollectionData, 'priceTiers');

    const promises = [];
    forEach(masterProductHandles, handle => {
      const connectedPromise = new Promise((resolve, reject) => {
        const signal = {
          onSuccess: resolve,
          onFailiure: reject,
        };

        dispatch(
          fetchCatalogMasterProduct({ handle, parentCollectionSortOrder, priceTiers, signal })
        );
      });
      promises.push(connectedPromise);
    });

    Promise.allSettled(promises).then(values => {
      dispatch({
        type: ACTIONS.FETCH_CATALOG_FINISH,
        payload: { values },
      });
    });
  };

export { fetchCatalogMasterProduct, setCatalogParentCollection, initCatalogParentCollection };
